import { call, all, put, takeLatest } from 'redux-saga/effects';
import {
  pieProtectSPI,
  // getEncryptionError,
  ENCRYPTION_INPUT,
} from '@vz-react/pie-encryption';
import * as Actions from './actions';
import * as ShippingActions from '../ShippingInfo/actions';
import * as Constants from './Constants';
// import { logError, FE_API_ERROR, FE_API_JS_ERROR } from '../../services/loggerService';
import * as notificationActions from '../../components/common/NotificationBar/actions';
import logger from '../../components/common/ErrorBoundary/logger_new';
import { getServiceUrlandE2eRequestId, isSequentialFlow } from '../../components/common/Helpers/index';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { apiUrls } from '../../constants/apiUrl';
import { checkInvalidCaseCartError } from '../../components/common/Helpers/commonLog';
import { getErrorLogObj } from '../../services/loggerService';
import { handleShippingInfodata, handleShippingInfoCatchCase } from '../ShippingInfo/sagas';
import { hideLoader, showLoader } from '../../components/common/Helpers/loader';

function* getZipDetails({ data }) {
  // debugger;
  let zipcodeError = false;
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_CREDIT_CHECK_ERROR, response: zipcodeError, errorMessage: null });
  try {
    const apiResponse = yield call(Actions.getZipDetails, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.GET_ZIP_DETAILS_SUCCESS, response: apiResponse.data });
    } else {
      // logError('getZipDetails', apiResponse.data.errors, FE_API_ERROR);
      // eslint-disable-next-line no-lonely-if
      if (apiResponse?.data?.errors) {
        zipcodeError = true;
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getZipDetails ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
      }
      yield put({ type: Constants.CEF_CREDIT_CHECK_ERROR, response: zipcodeError, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
    }
    yield put({ type: Constants.ERR_OCCURED, response: zipcodeError });
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
    yield put({ type: Constants.CEF_CREDIT_CHECK_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    // logError('getZipDetails', error, FE_API_JS_ERROR);
    if (error) {
      const errorLog = getErrorLogObj({
        message: 'GENERIC_PAGE',
        note: 'from getZipDetails sagas',
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().zipMarketDetailsUrl}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errorLog);
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* getCreditCheckOnClick({ data }) {
  // const notifyErrorMessage = data.notifyMessage;
  yield put(notificationActions.hideNotification());

  let isSuccess = true;
  // let encryptionErrorResponse;

  // // handle PIE encryption
  const encSSNNumber = yield call(pieProtectSPI, data.ssn, ENCRYPTION_INPUT.SSN);
  if (!encSSNNumber?.encryptionStatus?.isSuccess) {
    // encryptionErrorResponse = encSSNNumber;
  }
  isSuccess = encSSNNumber?.encryptionStatus?.isSuccess;
  if (!isSuccess) {
    // encryption failed - unable to load encrypted pin info
    const errorMsg = Constants.DEFAULT_ERR_MSG;
    yield put(notificationActions.showErrorNotification(errorMsg));
    return;
  }
  const creditCheckData = {
    ssn: encSSNNumber.encryptedData,
    fName: data && data.fName,
    lName: data && data.lName,
    address: data && data.addressLine1,
    line2: data && data.addressLine2,
    zipCode: data && data.zipCode,
    city: data && data.city,
    state: data && data.state,
    dob: data && data.dob,
    phoneNumber: data && data.phoneNumber,
  };
  yield put({ type: 'CREDIT_CHECK_DATA', response: creditCheckData });
  yield call(runCreditReview, creditCheckData);
}

function* runCreditReview(data) {
  let creditCheckApiError = false;
  let invalidCaseError = false;
  let serviceDetails = null;
  yield put({ type: 'CREDIT_CHECK_API_FAIL', response: creditCheckApiError });
  yield put({ type: Constants.CC_INVALIDCASE_ERROR, response: invalidCaseError });
  yield put({ type: Constants.CEF_CREDIT_CHECK_ERROR, response: creditCheckApiError, errorMessage: null });
  yield put(Actions.creditCheckFailReload());
  try {
    showLoader();
    if (isSequentialFlow()) {
      // In Sequential Self-setup flow, On click continue we will trigger the initiate-creditcheck call.
      yield put({ type: 'RUN_CREDIT_REVIEW_SUCCESS_RESPONSE', response: '' });
    }
    const apiResponse = yield call(Actions.runCreditReview, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      if (
        apiResponse.data.serviceHeader &&
        ((apiResponse.data.serviceHeader.statusMsg && apiResponse.data.serviceHeader.statusMsg === 'SUCCESS') ||
          (apiResponse.data.serviceHeader.statusCode && apiResponse.data.serviceHeader.statusCode === '00'))
      ) {
        yield put({ type: Constants.RUN_CREDIT_REVIEW_SUCCESS, response: true });
        yield put({ type: Constants.RUN_CREDIT_REVIEW_SUCCESS_DATA, response: true });
        yield put({ type: 'RUN_CREDIT_REVIEW_SUCCESS_RESPONSE', response: apiResponse.data.serviceBody });
        yield put({ type: 'RUN_CREDIT_DOWNPAYMENT_SUCCESS_RESPONSE', response: apiResponse.data.serviceBody });
        hideLoader();
      }
      yield put({ type: Constants.INITIATE_CREDIT_FAILED, response: '' });
    } else {
      if (apiResponse.data.errors[0]?.message === 'Looks like the address you entered is invalid.') {
        yield put({ type: 'INITIATE_CREDIT_FAILED_ADDRESS', response: true });
      }
      if (apiResponse?.data?.errors) {
        if (apiResponse?.status === 400 && checkInvalidCaseCartError(apiResponse.data.errors)) {
          invalidCaseError = true;
          yield put({ type: Constants.CEF_CREDIT_CHECK_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
        } else {
          creditCheckApiError = true;
          yield put({ type: Constants.CEF_CREDIT_CHECK_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
        }

        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `runCreditReview ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);

        serviceDetails = getServiceUrlandE2eRequestId('runCreditReview', apiResponse);
        yield put({ type: 'CREDIT_CHECK_API_FAIL', response: creditCheckApiError, serviceinfo: serviceDetails });
        yield put({ type: Constants.CC_INVALIDCASE_ERROR, response: invalidCaseError });
        hideLoader();
      }
      // logError('runCreditReview', apiResponse.data.errors, FE_API_ERROR);
      yield put({ type: Constants.INITIATE_CREDIT_FAILED, response: apiResponse.data.errors });
    }
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
    if (error) {
      creditCheckApiError = true;
      serviceDetails = {
        method: 'runCreditReview',
      };
      yield put({ type: 'CREDIT_CHECK_API_FAIL', response: creditCheckApiError, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_CREDIT_CHECK_ERROR, response: creditCheckApiError, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (error) {
      hideLoader();
    }
    // logError('runCreditReview', error, FE_API_JS_ERROR);
  }
}

export function* catchHandle(error) {
  yield put({ type: Constants.ERR_OCCURED });
  // logError('submitEidQestions', error, FE_API_JS_ERROR);
  logger({
    json: true,
    eventType: 'CustomLog',
    message: 'GENERIC_PAGE',
    note: 'from submitEidQestions sagas',
    messageType: 'ERROR',
    networkError: {
      error,
      response: error.response || null,
      message: error?.message,
      stack: error?.stack,
      subEventType: 'FeErrorS',
    },
  });
}

function* postEidQuestionsAnswers(eidData) {
  try {
    showLoader();
    const apiResponse = yield call(Actions.postEidQuestionsAnswersApi, eidData);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: 'EID_DATA_SUBMIT_SUCCESS_RESPONSE', response: apiResponse?.data?.serviceBody || apiResponse?.data });
      hideLoader();
    } else {
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getPlans ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
      hideLoader();
      yield put(hideLoader());
    }
  } catch (error) {
    // yield catchHandle(error);
    hideLoader();
  }
}

function* updateCreditCheckSuccess() {
  yield put({ type: Constants.RUN_CREDIT_REVIEW_SUCCESS, response: false });
}
// Posting d2d eid quetions.
function* postD2DEidQuestions(data) {
  try {
    showLoader();
    const apiResponse = yield call(Actions.postD2DEidQuestionsApi, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.D2D_EID_SEND_MESSAGE_RESPONSE, response: apiResponse });
      hideLoader();
    } else {
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getPlans ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
      hideLoader();
      yield put(hideLoader());
    }
  } catch (error) {
    // yield catchHandle(error);
    hideLoader();
  }
}

// getShippingDetailsFromAPI

function* getShippingInfoData({ data, homePhone }) {
  // debugger;
  const errorShipping = false;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  try {
    const apiResponse = yield call(ShippingActions.getDetails, data);
    yield handleShippingInfodata(data, homePhone, apiResponse);
  } catch (error) {
    yield handleShippingInfoCatchCase(error);
  }

  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* actionWatcher() {
  yield takeLatest(Constants.GET_ZIP_DETAILS_FROM_API, getZipDetails);
  yield takeLatest(Constants.RUN_CREDIT_REVIEW, runCreditReview);
  // yield takeLatest(Constants.RUN_D2D_CREDIT_REVIEW, runD2DCreditReview);
  yield takeLatest(Constants.GET_CREDIT_CHECK_INFO_ON_CLICK, getCreditCheckOnClick);
  yield takeLatest('POST_EID_QUESTIONS_ANSWERS', postEidQuestionsAnswers);
  yield takeLatest('UPDATE_CREDIT_REVIEW', updateCreditCheckSuccess);
  yield takeLatest('POST_D2D_EID', postD2DEidQuestions);
  // GET_SHIPPING_DETAILS_FROM_API
  yield takeLatest('GET_SHIPPING_DETAILS_FROM_API', getShippingInfoData);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
